export const environment = {
  production: false,
  LOG_LEVEL: 'LOG',
  // Strapi url
  //API_CDN_URL: 'https://wwwadminuat.icreditworks.com/api',
  API_DENTAL_CDN_URL: 'https://wwwadminuat.icreditworks.com/api',
  API_EQUIP_PROVIDER_CDN_URL: 'https://wwwadminuat.hspracticepay.com/api',
  // external services
  ARTICLES_URL: 'https://apiuat.icreditworks.com/api',
  LOAN_QUOTE_URL: 'https://apiuat.icreditworks.com/api',
  CHAT_API_URL: 'https://apiuat.icreditworks.com/api/chat/v1',
  SEND_APP_URL: 'https://apiuat.icreditworks.com/api/application/v1',
  ARTICLES_AUTHORS_URL: 'https://apiuat.icreditworks.com/api/security/v1',
  PROVIDER_API_BASE_URL: 'https://apiuat.icreditworks.com',

  ACCOUNT_HOST_URL: 'https://apiuat.icreditworks.com',
  NINTHWAVE_WIDGET_BASE_URL: 'https://4t6e4r.ppz.finance-api.services',
  // ninthwave
  NINTHWAVE_BASE_URL: 'https://qa-services.1fsapi.com/tnp-stg/consentsvc',

  // main auth creds
  AUTH_DSO_URL: 'https://apiuat.icreditworks.com/api/security/auth/v2',

  // second auth creds
  AUTH_LOANAPP_URL: 'https://uiuat.dsodentist.com/api/security/auth/v1',

  API_FRAUD_URL: 'https://apiuat.icreditworks.com/api',

  // uat error logger creds
  icwapi_providerApi: 'https://apiuat.icreditworks.com/api/provider/v1',
  icwLoggerApi: 'https://apiuat.icreditworks.com/api/system/v1',

  // anti-fraud creds
  tuScript: 'https://cdn-us.trustev.com/trustev.min.js',

  // provider portal
  providerLink: 'https://ppuat2.icreditworks.com/login',

  // account activation
  ccEmailAddress: 'networkactivationuat@icreditworks.com',

  //Android Play Store
  ANDROID_PLAYSTORE:'https://play.google.com/store/apps/details?id=com.iCreditWorks.icw',

  //iOS App Store
  iOS_APPSTORE:'https://apps.apple.com/us/app/icreditworks/id1455870277',

  //Assets CDN Base Url
  ASSETS_CDN_BASE_URL: 'https://assetsuat.icreditworks.com/public/website/assets'
}
